<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    
    <v-row v-if="componenteEvento.agregar_submodulo">
      <v-col class="d-flex flex-row-reverse pt-0">

        <!-- EXTENDER LICENCIAS -->
        <TableButtonComp iconBut="far fa-calendar-plus" normalButton textButton="Extender licencia" @click="addItem('extender')" />

         <!-- CREAR LICENCIAS -->
        <TableButtonComp iconBut="fas fa-plus" class="mx-3" normalButton textButton="Crear licencia" @click="addItem" />
      </v-col>
    </v-row>

  

    <v-row>
      <v-col cols="12">
        <ComundataTableComp placeholderTextsearch="Bucar licencias" :headers="LicenciasHeaders" :items="Datos"
          rowsPerPageText="Licencias por página" noResultsText="Sin licencias por mostrar" whitSearch>
          <slot>
            <v-row dense>
              <v-col cols="12" md="6" sm="6">
                <AutocompleteComp v-model="filtros.id_colegio" :items="colegios" textLabel="Colegio"
                  itemText="nombre_colegio" itemValue="id" @change="loadMain(true)"
                  :rules="[rul.selectReq, rul.required]" />
              </v-col>
              
              <v-col cols="12" md="6" sm="6">
                <AutocompleteComp v-model="filtros.id_tipo_licencia" :items="tipoLicenciasPorcolegio"
                  textLabel="Tipo de licencia" @change="loadMain()" itemValue="id" itemText="desc_tipo_licencia"
                  :rules="[rul.selectReq, rul.required]" />
              </v-col>
            </v-row>
          </slot>

          <template v-slot:fecha_inicioFiltro="{ item }">
            {{ item.fecha_inicio | filtroFecha }}
          </template>

          <template v-slot:fecha_finFiltro="{ item }">
            {{ item.fecha_fin | filtroFecha }}
          </template>

          <template v-slot:estadoValor="{ item }">
            <v-chip small dark class="font-weight-black" :color="item.licencia_color">
              {{ item.licencia_estado }}
            </v-chip>
          </template>

          <template v-slot:action_editar="{ item }">
            <TableButtonComp v-if="componenteEvento.editar_submodulo" editButton tooltipText="Editar Licencia"
              @click="editItem(item)" />
          </template>

          <template v-slot:action_borrar="{ item }">
            <TableButtonComp v-if="componenteEvento.borrar_submodulo" deleteButton tooltipText="Borrar Licencia"
              @click="showmodal(item.id)" />
          </template>
        </ComundataTableComp>
      </v-col>
    </v-row>

    <!-- Modal -->
    <v-form ref="formDatos" lazy-validation>
      <v-dialog v-model="dialog" persistent scrollable max-width="600px">
        <v-card>
          <v-card-title class="btn_otro">
            <label>{{ formTitle }}</label>
            <v-spacer />
            <v-btn fab dark x-small class="btn_style3" @click="dialog = false"><v-icon dark>fa-times</v-icon></v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="12" class="pb-0">
                <v-autocomplete label="Colegio" v-model="editedItem.id_colegio" :items="colegio" item-value="id"
                  item-text="nombre_colegio" prepend-icon="fa-school">
                  <!-- selectReq2-->
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="12" md="12" class="d-flex py-0" v-if="this.evento == 'extender' ">

                <v-radio-group
                v-model="radioState"
                  row
                  @change="handleCheckboxChange"
                >
                  <v-radio
                    label="Extender por tipo de licencia"
                    :value="false"
                  ></v-radio>
                  <v-radio
                    label="Extender todas las licencias"
                    :value="true"
                  ></v-radio>
                </v-radio-group>
              </v-col>
          
              <v-col cols="12" sm="12" md="12" class="py-0">
                <v-select label="Tipo de licencia" v-model="editedItem.id_tipo_licencia"
                  :items="tipoLicenciasPorcolegioModal" item-value="id" item-text="desc_tipo_licencia"
                  prepend-icon="fa-barcode" @change="filtrarDiasVencimineto(editedItem.id_tipo_licencia)"
                  :disabled="evento == 'extender'? radioState : false"
                  :rules="radioState ? [] : [rul.selectReq]"
                  >
                </v-select>
              </v-col>
          

              <v-col cols="12" sm="12" md="12" class="py-0" v-if="this.evento == 'agregar' || this.evento == 'extender'">
                <v-text-field label="Duración de licencias" type="number" v-model="editedItem.duracion_licencia"
                  prepend-icon="fa-sort-numeric-up-alt" :rules="[rul.required]" @keydown.native="filterKey"
                  @blur="checaValor(this)" min="0">
                </v-text-field>
              </v-col>

              <!-- @keypress="restrictCharsNumeros($event)"  // calcula la fecha de vencimiento  -->

              <!--
                            <v-col cols="12" sm="12" md="12" class="py-0" v-if="this.evento=='agregar'">
                                <v-text-field label="Fecha de Vencimiento" v-model="editedItem.fecha_vencimiento"
                                prepend-icon="fa-clock" >
                                </v-text-field>
                            </v-col>                            
                            -->

              <v-col cols="12" sm="12" md="12" class="py-0" v-if="this.evento == 'agregar'">
                <v-text-field label="Cantidad de licencias" type="number" v-model="editedItem.cantidad_licencia"
                  prepend-icon="fa-sort-numeric-up-alt" :rules="[rul.required]" @keydown.native="filterKey"
                  @blur="checaValor(this)" min="0">
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="12" class="py-0" v-if="this.evento == 'editar'">
                <v-text-field type="text" readonly v-model="editedItem.serie_licencia" label="Serial"
                  prepend-icon="fa-barcode"></v-text-field>
              </v-col>


              <v-col cols="12" sm="12" md="12" class="py-0">
                Estado: {{ normalizarMayusculas(editedItem.licencia_estado) }}
                <!--
                                <v-radio-group v-model="editedItem.estado" row label="Estado" class="pa-0">
                                    <v-radio :label="`Activo`" :value="1" color="teal"></v-radio>
                                    <v-radio :label="`Inactivo`" :value="0" color="error"></v-radio>
                                </v-radio-group>
                                -->
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn :style="{ color: '#ffffff' }" class="btn_block_style2" v-if="this.evento == 'editar'"
              :disabled="bloquearBotonGurdar" @click="saveItem(editedItem.id)">Guardar Cambios</v-btn>
            <v-btn :style="{ color: '#ffffff' }" class="btn_block_style2" v-if="this.evento == 'agregar' || this.evento == 'extender'"
              :disabled="bloquearBotonGurdar" @click="saveItem">Guardar</v-btn>
            <v-btn class="btn_style3" dark @click="dialog = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>

    <!--
        <pre>{{editedItem}}</pre>
        -->
    <confirm @aceptar="deleteItem" @cancelar="clear_confirm" :title="confirm.title" :active="confirm.active" />
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { LicenciasHeaders } from "../../../../helpers/headersTable.js";
import ComundataTableComp from "../../../../components/ComponentsEst/ComundataTablecomp.vue";
import TableButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
import AutocompleteComp from "../../../../components/ComponentsEst/AutocompleteComp.vue";

export default {
  components: {
    ComundataTableComp,
    TableButtonComp,
    AutocompleteComp,
  },
  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 2, id_modulo: 4 }, //sud_modulo y modulo

    LicenciasHeaders,
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////

    dialog: false,
    bloquearBotonGurdar: false,
    search: "",
    confirm: {
      id: 0,
      title: "",
      active: false,
    },

    //validaciones de formulario
    rul: {
      // empty:"",
      // empty: (value) => !value || "",
      required: (value) => !!value || "Campo requerido",
      inputReq: (value) => !!value || "Campo requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      selectReq2: (value) =>
        (value || "").length > 0 || "Debe seleccionar un campo de la lista",

      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
    },
    filtros: {},
    colegios: [],
    Datos: [],
    colegio: [],
    licencia_tipo: [],
    licencia_estado: [],
    radioState:false,
    evento: null,

    editedItem: {
      id_colegio: "",
      id_tipo_licencia: "",
    },
  }),

  computed: {
    formTitle() {
      return this.evento == "agregar" ? "Crear licencia" :  this.evento =="editar" ? "Editar licencia" : "Extender licencia"  ;
    },

    tipoLicenciasPorcolegio() {
      return this.licencia_tipo.filter(
        (tipo) => tipo.id_colegio == this.filtros.id_colegio
      );
    },

    tipoLicenciasPorcolegioModal() {
      return this.licencia_tipo.filter(
        (tipo) => tipo.id_colegio == this.editedItem.id_colegio
      );
    },
   
    ...mapGetters("login", ["componenteEvento"]),
  },
  mounted() {
    // this.loadMain();
    this.getAllColegios();
    this.getQuery();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    normalizarMayusculas(str) {
      if (!str) return ""
      // Para que solo la primera letra sea mayuscula y evitar los errores de ortografía registrados
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },

    clear_confirm() {
      this.confirm.id = 0;
      this.confirm.title = "";
      this.confirm.active = false;
    },

    //  ------- MOSTRAR TODOS LOS REGISTROS    --------
    async loadMain(selectColegio = false) {
      try {
        if (selectColegio == true) {
          this.filtros.id_tipo_licencia = "todos";
        }

        this.editedItem.id_colegio = this.filtros.id_colegio;
        this.editedItem.id_tipo_licencia = this.filtros.id_tipo_licencia;

        let query = `?id_colegio=${this.filtros.id_colegio}&id_tipo_licencia=${this.filtros.id_tipo_licencia}`;
        let response = await axios.get(`/manager/licencia/getMain${query}`);
        this.Datos = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async limpiarForm() {
      this.editedItem = {
        id_usuario: this.datoLogin.id,
        id: 0,
        serie_licencia: 0,
        cantidad_licencia: 1,
        id_colegio: Number(this.filtros.id_colegio),
        id_tipo_licencia: this.filtros.id_tipo_licencia,
        estado: 1,
        id_licencia_estado: 1,
        licencia_estado: null,
        duracion_licencia: null,
        evento: null,
        fecha_vencimiento: null,
      };
      this.resetValidation();
    },

    // Validar resetear campos al guardar
    resetValidation() {
      this.$refs.formDatos.resetValidation();
    },

    //----------- AREGAR Y EXTENDER REGISTROS  --------------
    async addItem(evento) {
      this.bloquearBotonGurdar = false;
      this.dialog = true;
      await this.getQuery();
      
      if(evento == 'extender' ){
        this.evento = evento;

      }else{
        
        this.evento = "agregar";
        this.editedItem.licencia_estado = this.licencia_estado.desc_estado;
      }
      this.limpiarForm();

    },    

    handleCheckboxChange(e) {
      // Limpia el campo cuando se cambia cualquier checkbox
      if(e){
      
        this.editedItem.id_tipo_licencia = '';
        
      }
    },

    //--------------EDITAR REGISTRO--------------
    editItem(item) {
      this.bloquearBotonGurdar = false;
      this.evento = "editar";
      this.getQuery();
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    // consulta Sencundaria para obtener colegio y tipo de licencia de los eventos (agregar y editar)
    getQuery() {

      axios
        .get("/manager/licencia/getQuery")
        .then((response) => {

          this.colegio = response.data.colegio;
          this.licencia_tipo = response.data.licTipo;
          this.licencia_estado = response.data.licEstado;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });


    },
/** 
 _________________________________________________________________________
|         FUNCION OBTENER TODOS LOS COLEGIOS EN VISTA LICENCIAS         */
    async getAllColegios() {
      await axios
        .get("/manager/colegio/colegiosPadres")
        .then((response) => {
          this.colegios = response.data;          
          // .map((c) => {
          //   c.id = c.id.toString();
          //   return c;
          // });
        })
        .catch((e) => {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `${e.error}`,
            tiempo: null,
          });
        });
    },

    async saveItem(id = "") {
      if (this.$refs.formDatos.validate()) {
        this.bloquearBotonGurdar = true;
        let extendResponse;
        try {
          this.editedItem.evento = this.evento;
          this.editedItem.extendAllLicencias = this.radioState;

          if (this.evento == "agregar") {
            await axios.post("/manager/licencia", this.editedItem);

          }

          if (this.evento == "editar") {
            await axios.put("/manager/licencia/" + id, this.editedItem);
          }
        
          if(this.evento == "extender"){
        
            extendResponse = await axios.put("/manager/licencia/extendLicencias", this.editedItem);
          
          }
        
          this.dialog = false;
          this.setEnviarMens({
            tipo: "S",
            mensaje: this.evento == 'agregar' || this.evento == 'editar' ? "¡Información creada con éxito!": extendResponse.data.message,
            tiempo: null,
          });
          this.limpiarForm();
          // this.loadMain();
        } catch (error) {
          this.bloquearBotonGurdar = false;
          this.setEnviarMens({ tipo: "E", mensaje: error.response.status == 403 ? error.response.data.message : "Ocurrió un error inesperado al agregar el registro.", tiempo: null });
        }
      }
    },

    async filtrarDiasVencimineto(tipoLicencia) {
      this.handleCheckboxChange()
      if (tipoLicencia) {
        let licenciaTipoFilter = this.licencia_tipo.filter(
          (el) => el.id == tipoLicencia
        );
        this.editedItem.duracion_licencia = await licenciaTipoFilter[0]
          .duracion_licencia;
        //this.fechaVencimiento()
      } else {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Debe Seleccionar un tipo de licencia`,
          tiempo: null,
        });
      }
    },

    // no esta funcionando la funcion getDate
    /*
            async fechaVencimiento(){
       
                if(this.editedItem.duracion_licencia){

                    var fecha = new Date()       
                    // const today = new Date();
                    //const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

                    //var fechaVenc =   fecha.setDate(fecha.getDate() + parseInt(this.editedItem.duracion_licencia)) 
                    var fecha_venc =   fecha.setDate(2) 
                      
                    //this.editedItem.fecha_vencimiento = fechaVenc.getDate() + '/' + (fechaVenc.getMonth() + 1) + '/' + fechaVenc.getFullYear();
                    alert(fecha_venc.getDate())
                 
                }else{
                    this.editedItem.fecha_vencimiento = null                   

                }                     
            },
            */

    //------------borrar Licencia -------------
    async showmodal(id) {
      this.confirm.id = id;
      this.confirm.title = "¿Está seguro de borrar este registro?";
      this.confirm.active = true;
    },
    async deleteItem() {
      try {
        //confirm("esta seguro que desea borrar este registro");
        let response = await axios.delete(
          "/manager/licencia/" + this.confirm.id
        );
        if (response.data.error == 1) {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `${response.data.message}`,
            tiempo: null,
          });
        
        } else {
          this.setEnviarMens({
            tipo: "S",
            mensaje: `${response.data.message}`,
            tiempo: null,
          });
          this.dialog = false;
          this.clear_confirm();
          this.loadMain();
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      
      }
    },
    filterKey(event) {
      // Si el código es menor que 48 (0) o mayor que 57 (9)
      if (
        event.keyCode == 69 ||
        event.keyCode == 190 ||
        event.keyCode == 189 ||
        event.keyCode == 187
      ) {
        //  // No se agrega
        //  if(event.keyCode != 8){
        event.preventDefault();
        //  }
      }
    },

    checaValor(item) {
      if(item) {
        // Obtener valor actual
        let valor = parseInt(item.value);
        // Si no es número o es menor de 1
        if (isNaN(valor) || valor < 1) {
          // Asignar 1
          item.value = 1;
        }
      }
    },
  },
};
</script>